import { c as _c } from "react/compiler-runtime";
import React from "react";
import { formatNumberWithCommas } from "@/helpers/Helpers";
import { FIELD_TO_LABEL_MAP } from "@/components/waves/memes/traits/schema";
import { Tooltip } from "react-tooltip";
import useIsMobileDevice from "@/hooks/isMobileDevice";
interface MemeDropTraitProps {
  readonly label: string;
  readonly value: string;
}
const convertValue = (value: string) => {
  if (value === "true") {
    return "Yes";
  }
  if (value === "false") {
    return "No";
  }
  if (!isNaN(Number(value))) {
    return formatNumberWithCommas(Number(value));
  }
  return value;
};
const MemeDropTrait: React.FC<MemeDropTraitProps> = t0 => {
  const $ = _c(17);
  const {
    label,
    value
  } = t0;
  const isMobile = useIsMobileDevice();
  let t1;
  if ($[0] !== value) {
    t1 = convertValue(value);
    $[0] = value;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const convertedValue = t1;
  if (label === FIELD_TO_LABEL_MAP.pointsLoki) {
    console.log(value, typeof value);
  }
  let t2;
  if ($[2] !== label) {
    t2 = <span className="tw-text-iron-400 tw-text-xs tw-mr-1.5 tw-font-normal">{label}:</span>;
    $[2] = label;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = `meme-drop-trait-${label}`;
  let t4;
  if ($[4] !== convertedValue || $[5] !== t3) {
    t4 = <span className="tw-text-iron-50 tw-text-sm tw-font-medium tw-truncate" data-tooltip-id={t3}>{convertedValue}</span>;
    $[4] = convertedValue;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== convertedValue || $[8] !== isMobile || $[9] !== label) {
    t5 = !isMobile && <Tooltip id={`meme-drop-trait-${label}`} place="top" style={{
      backgroundColor: "#1F2937",
      color: "white",
      padding: "4px 8px"
    }}><span className="tw-text-xs">{convertedValue}</span></Tooltip>;
    $[7] = convertedValue;
    $[8] = isMobile;
    $[9] = label;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t4 || $[12] !== t5) {
    t6 = <>{t4}{t5}</>;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t2 || $[15] !== t6) {
    t7 = <div className="tw-px-2 tw-py-1 tw-rounded-md tw-bg-iron-800 tw-flex tw-flex-col tw-gap-y-1.5">{t2}{t6}</div>;
    $[14] = t2;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  return t7;
};
export default MemeDropTrait;